import React, { useEffect, useState, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import DatePicker from 'react-datepicker';
import ReprintDelete from "../reprintDeleteWarningPopUp";
import "./ReprintDK.css";
import { AgGridReact } from "@ag-grid-community/react";
import PRHLoader from '../../lib/PRHLoader';
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule
]);
import { LicenseManager } from "@ag-grid-enterprise/core";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");
import "../MainBox.css";
import { FormGroup } from "react-bootstrap";


export default function ReprintDK(props) {
    const [reprintDK, setReprintDK] = useState(null);
    const [LikelyPis, setLikelyPis] = useState(null);
    const [reprintDKActive, setReprintDKActive] = useState(false);
    const [shouldUpdate, setshouldUpdate] = useState(false);
    const reprintUpdateTimeout = useRef(null);
    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true,
        },
        animateRows: true,
        accentedSort: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        suppressRowClickSelection: true,
        // onGridReady: (event) => event.api.sizeColumnsToFit(),

    }
    const fetchReprintsDK = async () => {
        try {

            const data = await apiHelper.inventoryPostCall('getReprintDK', { value: props.ISBN });
            if (data?.reprintDK) {
                setReprintDK(data?.reprintDK);
            } else {
                setReprintDK(null);
            }
            if (data?.likelyPis) {
                setLikelyPis(data?.likelyPis);
            } else {
                setLikelyPis(null);
            }
        } catch (error) {
            console.error("api failed getreprintDK", error);
        }
    }
    const handleCheckBoxChange = (e) => {
        setshouldUpdate(true);
        const { name, checked } = e.target;
        if (name === "upPrice" && checked == false) {
            setReprintDK(prev => ({ ...prev, [name]: checked, ["usPrice"]: false, ["canPrice"]: false, ["batch"]: null }));
        } else {
            setReprintDK(prev => ({ ...prev, [name]: checked }));
        }
    }


    const columnDefs = [
        {
            headerName: "FCD", field: "fcd", headerClass: "HeaderClassSource header-text-right", width: 70,
            cellClass: "CellClassSource cell-text-right", valueFormatter: params => convertDateFormat(params.value)
        },
        {
            headerName: "Qty", field: "quantity", headerClass: "HeaderClassSource header-text-right", width: 70,
            cellClass: "CellClassSource cell-text-right", valueFormatter: params => formatNumberWithCommas(params.value)
        },
        {
            headerName: "Req Delivery", field: "reqDelivery", headerClass: "HeaderClassSource header-text-right", width: 70,
            cellClass: "CellClassSource cell-text-right", valueFormatter: params => convertDateFormat(params.value)
        },
        {
            headerName: "Sched Delivery", field: "schedDelivery", headerClass: "HeaderClassSource header-text-right", width: 70,
            cellClass: "CellClassSource cell-text-right", valueFormatter: params => convertDateFormat(params.value)
        },
        {
            headerName: "Whse Due", field: "whseDate", headerClass: "HeaderClassSource header-text-right", width: 70,
            cellClass: "CellClassSource cell-text-right", valueFormatter: params => convertDateFormat(params.value)
        },
        {
            headerName: "PL Num", field: "piNumber", headerClass: "HeaderClassSource header-text-right", width: 70,
            cellClass: "CellClassSource cell-text-right",
        }
    ];

    function formatNumberWithCommas(number) {
        if (isNaN(number)) {
            return '';
        }
        // Convert number to string
        let str = number.toString();

        // Split the number into integer and decimal parts
        let parts = str.split(".");

        // Format integer part with commas
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // If decimal part exists and has one digit, add a trailing zero
        if (parts[1] && parts[1].length === 1) {
            parts[1] += "0";
        }

        // Join integer and decimal parts and return
        return parts.join(".");
    }
    const convertDateFormat = (dateStr) => {
        const date = new Date(dateStr);
        const day = date.getDate();
        // Use toLocaleString to get a short month name and convert it to lowercase.
        const monthRaw = date.toLocaleString('en-US', { month: 'short' }).toLowerCase();
        const month = monthRaw.charAt(0).toUpperCase() + monthRaw.slice(1).toLowerCase();
        // Get the last two digits of the year.
        const year = date.getFullYear().toString().slice(-2);
        return `${day}-${month}-${year}`;
    };

    const changeData = (e) => {
        const { name, value } = e.target;
        //     if ((name === "usPrice" || name === "canPrice") && (value != null && value.trim() != "") )
        setshouldUpdate(true);
        if (name == "suggestedDelivery") {
            /*         const date = new Date(value);
                     const year = date.getFullYear();
                     const month = String(date.getMonth() + 1).padStart(2, '0');
                     const day = String(date.getDate()).padStart(2, '0');
                     const formattedDate = `${year}-${month}-${day}`;*/

            const dateToSave = new Date(value);

            const formattedDate = new Date(dateToSave.setHours(0, 0, 0, 0));
            /*  const dateToSave = new Date(value);
              const data = new Date(dateToSave.getFullYear(), dateToSave.getMonth(), dateToSave.getDate());*/
            setReprintDK(prev => ({ ...prev, [name]: formattedDate }));
        } else {
            setReprintDK(prev => ({ ...prev, [name]: value }));//reprintdk form data
        }
    }
    const onClose = () => {
        setReprintDKActive(false);//reprints popup key
    }
    const titleAlert = (message, className = 'info', id) => {
        const statusAlertElement = document.getElementById(id);
        statusAlertElement.textContent = message;
        statusAlertElement.className = className;
    }

    const deleteReprintDK = async () => {
        updateData(true);
        setReprintDKActive(false);
    }

    const isEmptyOrNull = (value) => value == null || (typeof value === 'string' && value.trim() === "");

    const updateData = async (deleteFlag = false) => {

        if (shouldUpdate || deleteFlag) {
            setshouldUpdate(false);

            try {
                titleAlert("Updating Reprint DK.", "success", 'alert-reprint-update');
                if (reprintDK?.upPrice && isEmptyOrNull(reprintDK?.canPrice) && isEmptyOrNull(reprintDK?.usPrice) && !deleteFlag) {
                    titleAlert("UpPrice not saved, no price entered", "error", 'alert-reprint-update');
                    return;
                }

                const payload = {
                    UPN: props.UPN,
                    ISBN: reprintDK?.ISBN ?? props.ISBN,
                    SuggestedQty: reprintDK?.suggestedQty && !isNaN(Number(reprintDK?.suggestedQty)) ? Number(reprintDK?.suggestedQty) : null,//handle for null trim
                    SuggestedDelivery: reprintDK?.suggestedDelivery ?? null,
                    UPPrice: reprintDK?.upPrice ?? false,
                    USPrice: reprintDK?.usPrice !== '' && reprintDK?.usPrice !== null
                        ? parseFloat(reprintDK.usPrice)
                        : null,
                    CAPrice: reprintDK?.canPrice !== '' && reprintDK?.canPrice !== null
                        ? parseFloat(reprintDK.canPrice)
                        : null,
                    UserBatch: reprintDK?.batch ? reprintDK?.batch.trim() : '',//handle for null trim
                    ReprintNotes: reprintDK?.reprintNotes ? reprintDK?.reprintNotes.trim() : '',
                    InventoryManagement: reprintDK?.inventoryManagement ?? false,
                    Sales: reprintDK?.sales ?? false,
                    Finance: reprintDK?.finance ?? false,
                    HighPriority: reprintDK?.highPriority ?? false,
                    noReprint: reprintDK?.noReprint ?? false,
                    Delete: deleteFlag,
                    AgendaSection: reprintDK?.agendaSection ? reprintDK?.agendaSection.trim() : ''
                }
                //         console.info(reprintDK?.batch ? reprintDK?.batch.trim() : '');
                //         console.info(reprintDK?.batch);
                //         console.info(payload);
                const data = await apiHelper.inventoryPostCall("setReprintDK", payload);

                if (data && !deleteFlag) {

                    setReprintDK(data);
                    titleAlert(" Reprint DK updated successfully.", "success", 'alert-reprint-update');
                } else if (deleteFlag) {
                    setReprintDK(null);
                    titleAlert(" Reprint DK deleted successfully.", "success", 'alert-reprint-update');
                    //  console.info(reprintDK?.batch ? reprintDK?.batch.trim() : '');
                    //   console.info(reprintDK?.batch);
                }

            } catch (error) {
                console.error("api error updateReprintDK", error);
                titleAlert("Update Failed.", "error", 'alert-reprint-update')
            } finally {
                setTimeout(() => titleAlert('', 'info', 'alert-reprint-update'), 2000);
            }
        }
    }
    useEffect(() => {
        //  console.info(reprintDK);
        clearTimeout(reprintUpdateTimeout.current);
        reprintUpdateTimeout.current = setTimeout(() => {
            updateData(false);
        }, 1500);
        //false for delete flag 
    }, [reprintDK]);
    useEffect(() => {
        if (props?.ISBN)
            fetchReprintsDK();
    }, [props.ISBN])

    return (
        <>
            <Form noValidate="noValidate" className="ReprintDK" disabled={true}>

                <Row className="mt-3">
                    <Col md={12} className="fit-content">
                        <p className="ml-0 mb-0 padding-top-10">Reprint Inputs</p>
                    </Col>
                </Row>

                <div className="reprintdk-input">
                    <div className="rep-input">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <Form.Label >Suggested Qty</Form.Label>
                                        <input type="number" id="formGroupID" className="custom-input left-p-input right-align width80 pr-0" name="suggestedQty" min={0} value={reprintDK?.suggestedQty ?? ''} onChange={changeData} disabled={!props.isEditable} />
                                    </td>
                                    <td>
                                        <Form.Label >Suggested Delivery</Form.Label>
                                        <DatePicker
                                            portalId="root-portal"
                                            className="custom-input right-align"
                                            selected={reprintDK?.suggestedDelivery}
                                            onChange={(datevalue) => changeData({
                                                target: {
                                                    name: "suggestedDelivery",
                                                    value: datevalue
                                                }
                                            })}
                                            placeholderText="Select a date"
                                            dateFormat="MM/dd/yyyy"
                                            disabled={!props.isEditable}
                                        />
                                    </td>
                                    <td>
                                        <div className="disp-inline">
                                            <FormGroup>
                                                <Form.Label>UP Price</Form.Label><br />
                                                {props?.isEditable ? <input type="checkbox" className="checkbox ml-0" name="upPrice" value={reprintDK?.upPrice ?? ''} onChange={handleCheckBoxChange} checked={reprintDK?.upPrice ?? false} />
                                                    :
                                                    <input type="checkbox" className="checkbox ml-0 disabled-check" name="upPrice" value={reprintDK?.upPrice ?? ''} checked={reprintDK?.upPrice ?? false} />}
                                            </FormGroup>
                                            <FormGroup className="ml-4">
                                                <Form.Label >US Price</Form.Label><br />
                                                <input type="number" className={`custom-input left-p-input right-align width80 ${reprintDK?.upPrice && isEmptyOrNull(reprintDK?.canPrice) && isEmptyOrNull(reprintDK?.usPrice) ? 'empty-field' : ''}`} name="usPrice" min={0} value={reprintDK?.usPrice ??
                                                    ''} onChange={changeData} disabled={!props.isEditable || !reprintDK?.upPrice} />
                                            </FormGroup>

                                            <FormGroup className="ml-4">
                                                <Form.Label>CAN Price</Form.Label><br />
                                                <input type="number" className={`custom-input left-p-input right-align width80 ${reprintDK?.upPrice && isEmptyOrNull(reprintDK?.canPrice) && isEmptyOrNull(reprintDK?.usPrice) ? 'empty-field' : ''}`} name="canPrice" min={0} value={reprintDK?.canPrice ?? ''} onChange={changeData} disabled={!reprintDK?.upPrice || !props.isEditable} />
                                            </FormGroup>
                                        </div>
                                    </td>
                                    <td>
                                        <Form.Label >Batch</Form.Label>
                                        <input id="formGroupID" maxLength={10} onChange={changeData} className="custom-input left-p-input  width180" name="batch" value={reprintDK?.batch || ''} disabled={!reprintDK?.upPrice || !props.isEditable} />
                                    </td>
                                    <td>  <Form.Label >Reprint Notes</Form.Label>
                                        <input id="formGroupID" maxLength={256} onChange={changeData} className="custom-input left-p-input  width180   " name="reprintNotes" value={reprintDK?.reprintNotes || ''} disabled={!props.isEditable} />
                                    </td>
                                    <td>
                                        <div className="rep-del">
                                            <Form.Label >&nbsp;</Form.Label>
                                            <br />
                                            <button type="button"
                                                className="ISBNSubmit del-margin28 marg-0" onClick={() => setReprintDKActive(prev => !prev)} disabled={!reprintDK?.isbn || !props.isEditable}>Delete Data</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="pb-2">
                                    <td colSpan="2">
                                        <Form.Label >Controller (Last PI)</Form.Label>
                                        <input id="formGroupID" className="custom-input left-p-input" name="controller" value={reprintDK?.controller || ''} disabled={true} />
                                    </td>
                                    <td>
                                        <Form.Label >Pre-Meeting Approvals</Form.Label>
                                        <br />
                                        <div className="disp-inline">
                                        <div className="disp-inline">
                                            {props?.isEditable ?
                                                <div className="disp-inline">
                                                    <input type="checkbox" name="inventoryManagement" value={reprintDK?.inventoryManagement ?? ''} onChange={handleCheckBoxChange} checked={reprintDK?.inventoryManagement ?? false} className="mr-1 ml-0" /></div>
                                                :
                                                    <div className="disp-inline"><input type="checkbox" name="inventoryManagement" checked={reprintDK?.inventoryManagement ?? false} className="mr-1 ml-0 disabled-check" />
                                                   
                                                </div>} <Form.Label className="mr-1 align-bot" >Inventory Management</Form.Label>
                                        </div>
                                            <div className="disp-inline">
                                                {props?.isEditable ? <input type="checkbox" name="sales" value={reprintDK?.sales ?? ''} onChange={handleCheckBoxChange} checked={reprintDK?.sales ?? false} className="mr-1" />
                                                    :
                                                    <input type="checkbox" name="sales" checked={reprintDK?.sales ?? false} className="mr-1 disabled-check" />
                                                } <Form.Label className="mr-1 align-bot"> Sales</Form.Label>

                                            </div>

                                            <div className="disp-inline">
                                                {props?.isEditable ? <input type="checkbox" name="finance" value={reprintDK?.finance ?? ''} onChange={handleCheckBoxChange} checked={reprintDK?.finance ?? false} className="mr-1" />
                                                    :
                                                    <input type="checkbox" name="finance" checked={reprintDK?.finance ?? false} className="mr-1 disabled-check"/>}
                                                <Form.Label className="mr-1 align-bot"> Finance</Form.Label>
                                            </div>
                                      </div>
                                    </td>
                                    <td>  <span id="alert-reprint-update"></span></td>
                                    <td colSpan="3" rowSpan="2">
                                        {props?.metaData.salesstatus === "IN" && (


                                            <Form.Group className="ml-4 left125">
                                                <Form.Label>FL Likely Pis</Form.Label>
                                                {LikelyPis ? (
                                                    <div className="ag-theme-alpine" style={{ height: "51px", width: "421px", overflow: "hidden", scroll: "none" }}>
                                                        <AgGridReact
                                                            rowData={[LikelyPis]}
                                                            columnDefs={columnDefs}
                                                            gridOptions={gridOptions} domLayout="autoHeight"
                                                        />
                                                    </div>
                                                ) : (
                                                    <span style={{ fontSize: "12px" }}><br /> No data available</span>
                                                )}
                                            </Form.Group>


                                        )}

                                    </td>

                                </tr>
                                <tr>
                                    <td>

                                        <Form.Label >High Priority</Form.Label><br />
                                        {props?.isEditable ?
                                            <input type="checkbox" className="ml-0" name="highPriority" value={reprintDK?.highPriority ?? ''} onChange={handleCheckBoxChange} checked={reprintDK?.highPriority ?? false} />
                                            : <input type="checkbox" className="ml-0 " name="highPriority" defaultChecked={reprintDK?.highPriority ?? false} />}                                </td>

                                    {/*    <Col md={1} className="fit-content">
                        <Form.Group >
                            <Form.Label >No Reprint</Form.Label>
                                    <br />
                                    {props?.isEditable ?
                                        <input type="checkbox" name="noReprint" value={reprintDK?.noReprint ?? ''} onChange={handleCheckBoxChange} checked={reprintDK?.noReprint ?? false} />
                                        :
                                        <input type="checkbox" name="noReprint" value={reprintDK?.noReprint ?? ''}  checked={reprintDK?.noReprint ?? false} />
                                    }
                        </Form.Group>
                            </Col>*/}
                                    <td>
                                        <Form.Label >Agenda Section</Form.Label>
                                        <select id="formGroupID" className="custom-input left-p-input" name="agendaSection" onChange={changeData} value={reprintDK?.agendaSection ?? ''} disabled={!reprintDK?.isbn || !props.isEditable}>
                                            <option value='' disabled>select...</option>

                                            <option key="1 FL" value="1 FL">1 FL</option>
                                            <option key="2 FL Backup" value="2 FL Backup">2 FL Backup</option>
                                            <option key="3 BL" value="3 BL">3 BL</option>
                                            <option key="4 Other" value="4 Other">4 Other</option>

                                        </select>                                </td>
                                    <td>
                                        <Form.Label >Reprint Inputs Updated </Form.Label>
                                        <br />
                                        <input type="text" className="custom-input width180" value={reprintDK?.user ?? ''} disabled={true}></input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>




                        {/* {props?.metaData.salesstatus === "IN" ?
                                <Col md={7} className="fit-content">
                                    <Form.Group >
                                        <Form.Label >FL Likely Pis</Form.Label>
                                    {LikelyPis ?
                             
                                        <div >
                                                   
                                            <table className="LikelyPis">
                                                <tr>
                                                    <th >FCD</th>
                                                    <th >Qty</th>
                                                    <th >Req Delivery</th>
                                                    <th >Sched Delivery</th>
                                                    <th >Whse Due</th>
                                                    <th >PL Num</th>
                                                </tr>
                                                <tr>
                                                        <td >{convertDateFormat(LikelyPis?.fcd)}</td>
                                                        <td >{formatNumberWithCommas(LikelyPis?.quantity)}</td>
                                                        <td >{convertDateFormat(LikelyPis?.reqDelivery)}</td>
                                                        <td >{convertDateFormat(LikelyPis?.schedDelivery)}</td>
                                                        <td >{convertDateFormat(LikelyPis?.whseDate)}</td>
                                                        <td >{LikelyPis?.piNumber}</td>
                                                </tr>
                                                </table>
                                            </div> : <span style={{ fontSize:"12px" }}><br /> No data available</span>}
                                    </Form.Group>
                                </Col>:<></>}*/}


                    </div>

                </div>
            </Form >
            {reprintDKActive && <ReprintDelete onClose={onClose} reprintActive={reprintDKActive} deleteReprint={() => deleteReprintDK()}  ></ReprintDelete>}
        </>
    )
}